module.exports = __webpack_public_path__ + "static/img/commerce.9c53df33.png";